import React, { useState, useRef, useEffect } from "react";
import MapTo from "../utils/mapto";
import ReferencesIconClose from "@images/icons/reference-close.svg";
import styled from "styled-components";

const StyledReferences = styled.div`
	a {
		text-decoration: underline;
		color: #000000b2
	}
`;

const References = (content) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const contentRef = useRef(null);
	const [contentHeight, setContentHeight] = useState(0);
	// const item = content.references;

  const parsedContent = JSON.parse(content.references.text.raw);
  const isSingularReference = parsedContent?.content[0]?.nodeType === 'ordered-list' && parsedContent?.content[0]?.content.length === 1;

	const updateContentHeight = () => {
		if (contentRef.current) {
			setContentHeight(contentRef.current.scrollHeight);
		}
	};

	useEffect(() => {
		updateContentHeight();
	}, [content.references, isExpanded]);

	useEffect(() => {
		window.addEventListener('resize', updateContentHeight);

		return () => {
			window.removeEventListener('resize', updateContentHeight);
		};
	}, []);

	const toggleAccordion = () => {
		setIsExpanded(!isExpanded);
	};

	return (
		<StyledReferences className="flex flex-col max-w-default mx-auto rounded-top_48  xl:px-0 lg:max-w-lg xl:max-w-default">
			<div className="flex items-center justify-between w-full py-[32px] px-6 text-dark_green font-gt_walsheim_bold lg:px-[0] ">
				<span className="text-h4 text-dark_green font-bold">Reference{isSingularReference ? '' : 's'}</span>
				<button
					onClick={toggleAccordion}
					className="ref-toggle focus:outline-none hover:scale-105 transition-transform duration-300"
					aria-expanded={isExpanded}
				>
					<img
						src={ReferencesIconClose}
						alt="References"
						className="transition-transform duration-300 w-[80px] h-[50px]"
						style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
					/>
				</button>
			</div>
			<div
				ref={contentRef}
				className="ref-content transition-all duration-500 ease-in-out overflow-hidden [&>div]:pb-[32px] [&>div]:px-[25px] lg:[&>div]:px-[0]"
				style={{ maxHeight: isExpanded ? `${contentHeight}px` : '0', opacity: isExpanded ? 1 : 0 }}
			>
				<MapTo key={content.references.id} items={{ ...content.references, nodeStyles: { listItem: 'lg:!text-[16px] text-[14px]  text-[#000000B2] !leading-[125%] pb-[10px] marker:text-dark_green marker:font-bold' } }}></MapTo>
			</div>
		</StyledReferences>
	);
};

export default References;
